import AppRoutes from './routes/AppRoutes';
import { Toaster } from 'react-hot-toast';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { useEffect } from 'react';
import { profileApi } from './features/profile/api/profile.api';
import { useAuth } from './context/AuthContext';
function App() {

  const {getMe}=useAuth()
  useEffect(() => {
   getMe();
  }, []);
  return (
    <ErrorBoundary>
      <Toaster position="top-right" containerStyle={{ zIndex: 99999 }} />
      <AppRoutes />
    </ErrorBoundary>
  );
}
export default App;
